import clsx from 'clsx';
import React, { useState } from 'react';

import styles from './styles.module.scss';

export type GdprColorScheme = 'light' | 'dark';

const GdprOptIn = ({ colorScheme }: { colorScheme: GdprColorScheme }) => {
  const [optIn, setOptIn] = useState<boolean>(false);

  return (
    <div className={styles.marketingOptInContainer}>
      <label className={clsx(styles.marketingOptIn, 'marketing-opt-in')}>
        <span
          className={clsx(styles.formControlText, {
            ['text-black']: colorScheme === 'light',
            ['text-white']: colorScheme === 'dark',
          })}
        >
          Get breaking news, relevant articles, and special event &amp; editorial invites
        </span>
        <input
          type="checkbox"
          value="1"
          name="user[opt_in]"
          className={clsx(styles.optInCheckbox, 'opt-in')}
          onChange={() => setOptIn(!optIn)}
          checked={optIn}
        />
        <span className={clsx(styles.checkboxFill, { [styles.checkboxChecked]: optIn })}>
          <span className={clsx(styles.innerCheckbox, { [styles.filled]: optIn })}></span>
        </span>
      </label>
    </div>
  );
};

export default GdprOptIn;
